import React from 'react';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import { InputFields } from './components/InputFields/InputFields';
import ModalWindows from './components/ModalWindows/ModalWindows';
import classNames from 'classnames';
import style from './EditFormForClientManager.module.scss';

interface IProps {
	isVisible: boolean;
}

const EditFormForClientManager: React.FC<IProps> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses}>
			<WithAdditionalValidationState>
				<InputFields />
				<ModalWindows />
			</WithAdditionalValidationState>
		</div>
	);
};

export default React.memo(EditFormForClientManager);
